<template>
  <v-card outlined :class="editOnly && 'no-border mt-n4'">
    <div v-if="newCampaign.category !== 'draw'">
      <v-card-title
        class="subtitle-3 d-flex"
        :class="editOnly && 'py-0 my-0'"
        style="word-break: normal; justify-content: space-evenly; flex-wrap: nowrap"
      >
        <v-btn
          v-if="!editOnly"
          class="text-capitalize"
          depressed
          elevation="8"
          fab
          dark
          @click="$emit('prev')"
        >
          <v-icon size="20" v-text="icons.mdiArrowLeft"></v-icon>
        </v-btn>

        <span class="text-h4 pl-5 pr-5">{{
          newCampaign.category && translations.customerReward[lang]
        }}</span>

        <v-btn
          v-if="!editOnly"
          class="text-capitalize"
          depressed
          :elevation="(canGoToNextStep && !this.loading && 8) || 0"
          dark
          fab
          :disabled="!canGoToNextStep || loading"
          @click="goToNextStep()"
        >
          <v-icon size="20" v-text="icons.mdiArrowRight"></v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text :class="editOnly && 'py-0 my-0'" class="text--primary pt-5">
        <v-row :class="editOnly && 'py-0 my-0'" class="flex-column justify-center align-center">
          <v-col v-if="!editOnly" cols="12" md="12" class="d-flex justify-center pa-5 pb-0">
            <span class="text-center text-subtitle-2 text--secondary">{{
              translations[`customerRewardDescription_${storeMode}`][lang]
            }}</span>
          </v-col>
          <v-card-text class="text--primary pt-5">
            <v-row class="d-flex justify-center transition-all mw-100">
              <v-col
                v-for="(item, index) in rewardTypes"
                :key="index"
                cols="12"
                sm="12"
                md="3"
                class="d-flex flex-column justify-center align-center ma-2 mt-0 pa-12 pt-6 pb-2 select-category transition-all text-subtitle-2 rounded-lg text-center"
                :style="{
                  'min-width': '265px;',
                  'max-width': (rewardTypes.length % 4 == 0 && '150px') || undefined,
                }"
                :class="[
                  rewardTypes.length % 4 == 0 && 'pl-6 pr-6 pt-3 pb-1',
                  selectedReward.system == item.system && 'selected-condition',
                  !item.categories.includes(newCampaign.category) && 'display-none',
                  editOnly && selectedReward.system !== item.system && 'display-none',
                ]"
                @click="attachRewardType(item)"
              >
                <v-sheet
                  class="rounded-lg pa-3 text-center pr-0 pl-0 mw-100 text-subtitle-2 border-grey d-flex justify-center"
                  style="overflow: hidden"
                >
                  <v-icon
                    class="ma-5 text-subtitle-1"
                    :class="[item.system == 'multiplier' && 'mr-0 ml-n2']"
                    size="80"
                    v-text="item.icon"
                  ></v-icon>

                  <v-icon
                    v-if="item.system == 'multiplier'"
                    class="ma-5 ml-n5 text-subtitle-1"
                    size="80"
                    v-text="icons.mdiNumeric"
                  ></v-icon>
                </v-sheet>
                <div class="pa-3 text-center pr-0 pl-0 mw-100">
                  {{ item.name[lang] }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <div
            ref="conditions"
            id="conditions"
            style="min-height: 200px; max-width: 700px; width: 100%"
          >
            <v-col cols="12" sm="12" md="12" class="d-flex flex-column">
              <v-col
                v-if="['multiplier'].includes(selectedReward.system)"
                cols="12"
                sm="12"
                md="12"
                class="d-flex flex-column"
              >
                <v-row>
                  <v-col cols="12" md="12" class="d-flex justify-center pa-3 pb-0">
                    <span class="text-center text-h5">{{
                      translations[`multi_${storeMode}_choose`][lang]
                    }}</span>
                  </v-col>

                  <v-col cols="12" md="12" class="d-flex justify-center pa-3 pb-0">
                    <span class="text-center text-subtitle-2 text--secondary">{{
                      translations[`multi_${storeMode}_desc`][lang]
                    }}</span>
                  </v-col>
                </v-row>

                <v-row class="d-flex justify-center transition-all mw-100">
                  <v-col cols="12">
                    <v-radio-group
                      class="mt-2 pt-0"
                      hide-details
                      v-model="selectedReward.options.campaign_reward.multi_points_ratio"
                      @change="checkValue"
                    >
                      <v-row no-gutters class="d-flex justify-center">
                        <v-col
                          v-for="(multi, i) in multiPoints"
                          :key="i"
                          cols="auto"
                          class="pr-2 mr-1"
                        >
                          <v-radio color="secondary" :value="multi.value">
                            <template v-slot:label>
                              <!-- <v-icon v-text="gender.icon"></v-icon> -->
                              <h4 class="subtitle-2" v-text="multi.title"></h4>
                              <v-divider
                                v-if="i < multiPoints.length - 1"
                                vertical
                                class="ml-5 mr-3"
                                style="max-width: 3px"
                              ></v-divider>
                            </template>
                          </v-radio>
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-if="['coupon'].includes(selectedReward.system)"
                cols="12"
                sm="12"
                md="12"
                class="d-flex flex-column"
              >
                <v-row>
                  <v-col cols="12" md="12" class="d-flex justify-center pa-3 pb-0">
                    <span class="text-center text-h5">{{ translations.chooseCoupon[lang] }}</span>
                  </v-col>

                  <v-col cols="12" md="12" class="d-flex justify-center pa-3 pb-0 pt-2">
                    <span class="text-center text-subtitle-2 text--secondary"
                      >{{ translations.chooseCouponRewardDesc[lang] }}.
                      <span class="text-center text-subtitle-2 text--secondary">{{
                        translations.redemptionPeriodDesc[lang]
                      }}</span></span
                    >
                  </v-col>
                </v-row>

                <v-row class="d-flex justify-center transition-all mw-100">
                  <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="9" class="pr-1">
                    <v-autocomplete
                      v-model="selectedReward.options.campaign_reward.gift_id"
                      :items="availableCoupons"
                      item-text="gift_title"
                      item-value="gift_id"
                      menu-props="offsetY"
                      :label="translations.coupon[lang]"
                      outlined
                      prepend-inner-icon="mdi-ticket-percent"
                      dense
                      class="mt-n1"
                      hide-details
                      :search-input.sync="searchCoupons"
                      :loading="loading"
                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="3" class="pl-1">
                    <b-text-field
                      v-model="selectedReward.options.campaign_reward.coupon_claim_valid_days"
                      :label="translations.redemptionPeriod[lang]"
                      type="number"
                      class="pr-1 mt-n1"
                    ></b-text-field>
                  </v-col>
                </v-row>

                <div>
                  <v-checkbox
                    v-model="couponHasSms"
                    color="secondary"
                    class="mt-1 pt-2 no-messages"
                  >
                    <template v-slot:label>
                      <h4 class="subtitle-2">
                        {{ translations.smsRewardSend[lang] }}
                      </h4>
                    </template>
                  </v-checkbox>
                </div>
                <v-row class="d-flex justify-center transition-all mw-100">
                  <v-col v-if="couponHasSms" cols="12" outlined class="pr-0">
                    <v-row class="d-flex justify-center transition-all mw-100">
                      <v-col cols="12" outlined class="pr-0">
                        <div
                          class="pa-5 pb-0 pt-2 text-center text-subtitle-2 text--secondary font-weight-light"
                        >
                          <span class="">{{ translations.dynamicRewardSmsDesc1[lang] }}</span>
                          <span class="text--primary font-weight-bold">{voucher}</span>
                          <span class="">{{ translations.dynamicRewardSmsDesc2[lang] }}</span>
                          <span class="text--primary font-weight-bold">{code}</span>
                          <span class="">{{ translations.dynamicRewardSmsDesc3[lang] }}</span>
                          <div
                            class="pa-1 pb-0 pt-2 text-center text-subtitle-2 text--secondary font-weight-light font-italic"
                          >
                            *<span class="">{{ translations.dynamicRewardSmsVariable[lang] }}</span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <b-mentionable :mentionable-items="mentionableItems">
                      <b-textarea
                        v-model="selectedReward.options.campaign_reward.notification[smsLang]"
                        :label="translations.smsRewardContent[lang]"
                        isSms
                      >
                        <template v-slot:append>
                          <b-lang-menu v-model="smsLang" type="inner"></b-lang-menu>
                        </template>
                      </b-textarea>
                    </b-mentionable>
                    <div v-if="couponHasSms" class="footer-options-reward-sms">
                      <v-expansion-panels
                        focusable
                        accordion
                        flat
                        hover
                        tile
                        :disabled="!couponHasSms || !hasSmsContent"
                        v-model="testPanel"
                        class="test-panel transition-all test-reward-sms-panel"
                      >
                        <v-expansion-panel>
                          <v-expansion-panel-header ripple class="pt-2 pb-2 rounded">
                            Test
                            <template v-slot:actions>
                              <v-icon color="secondary">$expand</v-icon>
                            </template>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <b-card
                              hide-title
                              hide-default-footer
                              :cancel-btn="false"
                              elevation="0"
                              :submit-text="translations.sendButton"
                              @cancel="testPanel = false"
                            >
                              <div
                                class="subtitle-1 font-weight-medium py-3"
                                style="min-width: 250px; margin-left: -16px"
                              >
                                <v-text-field
                                  v-model="testMobile"
                                  :label="translations.mobileInputLabel[lang]"
                                  class="pt-0 pr-4 reward-sms-test-mobile"
                                  no-margin-top
                                  hide-details
                                ></v-text-field>
                              </div>
                              <v-card-actions class="d-flex justify-center">
                                <v-btn
                                  color="secondary"
                                  :loading="testSending"
                                  depressed
                                  :disabled="!isMobileValid"
                                  @click="sendTestSms"
                                  >{{ translations.sendButton[lang] }}</v-btn
                                >
                              </v-card-actions>
                            </b-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-if="['points'].includes(selectedReward.system)"
                cols="12"
                sm="12"
                md="12"
                class="d-flex flex-column"
              >
                <v-row>
                  <v-col cols="12" md="12" class="d-flex justify-center pa-3 pb-0">
                    <span class="text-center text-h5">{{
                      translations[`type_reward_${storeMode}_number`][lang]
                    }}</span>
                  </v-col>

                  <v-col cols="12" md="12" class="d-flex justify-center pa-3 pb-0 pt-2">
                    <span class="text-center text-subtitle-2 text--secondary">{{
                      translations[`reward_${storeMode}_description`][lang]
                    }}</span>
                  </v-col>
                </v-row>

                <v-row class="d-flex justify-center transition-all mw-100 mb-3">
                  <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="9" class="pr-1 pb-0">
                    <b-text-field
                      v-model="selectedReward.options.campaign_reward.reward_points"
                      :label="translations[`reward_${storeMode}`][lang]"
                      type="number"
                      class="pr-1 mt-n1"
                    ></b-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-row
                v-if="
                  newCampaign.category == 'action' &&
                  ['points', 'multiplier'].includes(selectedReward.system)
                "
                class="d-flex justify-center transition-all mw-100"
              >
                <v-col cols="12" xs="12" sm="12" md="12" lg="11" xl="11" class="pa-3">
                  <span class="text-center text-subtitle-2 text--secondary">{{
                    translations[`${storeMode}ShareDescription`][lang]
                  }}</span>
                </v-col>
                <v-col cols="12" outlined class="pr-0 pt-0">
                  <v-row class="d-flex justify-center transition-all mw-100">
                    <v-col cols="10" outlined class="pr-0 pb-0">
                      <div
                        class="pa-5 pb-0 pt-0 mb-n4 text-center text-subtitle-2 text--secondary font-weight-light"
                      >
                        <span class="">{{ translations.dragSharePointsDesc[lang] }}</span>
                      </div>
                    </v-col>
                  </v-row>
                  <v-slider
                    v-model="selectedReward.options.invoicing_settings.both_percentages.company"
                    min="0"
                    max="100"
                    class="mt-8"
                    track-color="green"
                    color="orange"
                    thumb-color="secondary"
                    hide-details
                    @click:append="
                      () => {
                        selectedReward.options.invoicing_settings.both_percentages.company = 100;
                      }
                    "
                    @click:prepend="
                      () => {
                        selectedReward.options.invoicing_settings.both_percentages.company = 0;
                      }
                    "
                  >
                    <template v-slot:append>
                      <v-row class="mt-n12 mxw-150px">
                        <v-col cols="12" md="12" class="d-flex justify-center pb-0 mb-0">
                          <v-icon
                            size="70"
                            v-text="icons.mdiStore"
                            color="green"
                            @click="
                              () => {
                                selectedReward.options.invoicing_settings.both_percentages.company = 0;
                              }
                            "
                          ></v-icon>
                        </v-col>
                        <v-col cols="12" md="12" class="d-flex justify-center pb-0 mb-1 pt-0 mt-n2">
                          <span
                            class="text-center text-subtitle-2 text--secondary font-weight-light"
                            >{{ translations.store[lang] }}</span
                          >
                        </v-col>
                        <v-col cols="12" md="12" class="d-flex justify-center pt-0">
                          <b-text-field
                            v-model="storePercentage"
                            :clearable="false"
                            class="mt-n1 pt-0"
                            append-icon="mdi-percent"
                            type="number"
                            style="max-width: 85px"
                          ></b-text-field>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:prepend>
                      <v-row class="mt-n12 mxw-150px">
                        <v-col cols="12" md="12" class="d-flex justify-center pb-0 mb-0">
                          <v-icon
                            size="70"
                            v-text="icons.mdiDomain"
                            color="orange"
                            @click="
                              () => {
                                selectedReward.options.invoicing_settings.both_percentages.company = 100;
                              }
                            "
                          ></v-icon>
                        </v-col>
                        <v-col cols="12" md="12" class="d-flex justify-center pb-0 mb-1 pt-0 mt-n2">
                          <span
                            class="text-center text-subtitle-2 text--secondary font-weight-light"
                            >{{ translations.company[lang] }}</span
                          >
                        </v-col>
                        <v-col cols="12" md="12" class="d-flex justify-center pt-0">
                          <b-text-field
                            v-model="
                              selectedReward.options.invoicing_settings.both_percentages.company
                            "
                            :clearable="false"
                            class="mt-n1 pt-0"
                            append-icon="mdi-percent"
                            type="number"
                            style="max-width: 85px"
                          ></b-text-field>
                        </v-col>
                      </v-row>
                    </template>
                  </v-slider>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-row>
      </v-card-text>
    </div>
    <div v-else>
      <Step5Reward @next="goToStep(7)" @prev="$emit('prev')" />
    </div>
    <v-divider v-if="!editOnly"></v-divider>
  </v-card>
</template>

<script>
import {
  mdiArrowLeft,
  mdiLinkVariant,
  mdiMenuRight,
  mdiArrowRight,
  mdiCalendar,
  mdiCalendarMonth,
  mdiMenuUp,
  mdiMenuDown,
  mdiGiftOutline,
  mdiTicketPercentOutline,
  mdiAlphaX,
  mdiNumeric,
  mdiStore,
  mdiDomain,
  mdiClose,
} from '@mdi/js';
import { mapMutations, mapState, mapActions } from 'vuex';
import translations from '@/utils/translations/loyaltyPanel/campaigns/newCampaign';
import Step5Reward from '@/components/loyaltyPanel/newCampaign/Step5Reward';
import debounce from 'lodash/debounce';

export default {
  name: 'Step5',

  mixins: [translations],
  components: { Step5Reward },

  props: {
    editOnly: {
      type: Boolean,
      default: false,
    },
    initialCampaign: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    icons: {
      mdiArrowLeft,
      mdiLinkVariant,
      mdiMenuRight,
      mdiArrowRight,
      mdiCalendar,
      mdiCalendarMonth,
      mdiMenuUp,
      mdiMenuDown,
      mdiNumeric,
      mdiStore,
      mdiDomain,
    },
    searchCoupons: '',
    smsLang: '',
    disableBtn: true,
    couponHasSms: false,
    // sharePoints: true,
    changeSmsElAuto: true,
    changeSmsItAuto: true,
    changeSmsEnAuto: true,
    storePercentage: 0,
    multiPoints: [
      {
        title: '2X',
        value: 2,
      },
      {
        title: '3X',
        value: 3,
      },
      {
        title: '4X',
        value: 4,
      },
      {
        title: '5X',
        value: 5,
      },
      {
        title: '10X',
        value: 10,
      },
    ],
    percentageError: '',

    rewardTypes: [
      {
        name: {
          en: 'Points',
          el: 'Πόντοι',
          it: 'Punti',
        },
        selected: false,
        icon: mdiGiftOutline,
        categories: ['informative', 'action'],
        system: 'points',
        options: {
          campaign_reward: { reward_points: null },
          invoicing_settings: {
            company: true,
            store: false,
            both: false,
            both_percentages: {
              company: 100,
            },
          },
        },
      },
      {
        name: {
          en: 'Coupon',
          el: 'Κουπόνι',
          it: 'Buono',
        },
        selected: false,
        icon: mdiTicketPercentOutline,
        categories: ['informative', 'action'],
        system: 'coupon',
        options: {
          campaign_reward: {
            gift_id: null,
            notification: {
              en: '',
              el: '',
              it: '',
            },
            coupon_claim_valid_days: null,
          },
        },
      },
      {
        name: {
          en: 'Multiple Points',
          el: 'Πολλαπλασιαστής πόντων',
          it: 'Moltiplicatore di punti',
        },
        selected: false,
        icon: mdiAlphaX,
        categories: ['action'],
        system: 'multiplier',
        options: {
          campaign_reward: {
            multi_points_ratio: null,
          },
          invoicing_settings: {
            company: true,
            store: false,
            both: false,
            both_percentages: {
              company: 100,
            },
          },
        },
      },
      {
        name: {
          en: 'No Reward',
          el: 'Χωρίς Επιβράβευση',
          it: 'Nessuna Ricompensa',
        },
        selected: false,
        icon: mdiClose,
        categories: ['informative', 'action'],
        system: 'no_reward',
        options: { campaign_reward: { reward_points: 0 } },
      },
    ],
    notification: {
      success: false,
      error: '',
      // validate: () =>{
      //     if (!this.newCampaign.campaign_reward.notification[this.smsLang]) {

      //         this.error.body = this.errorMessages.bodyRequired[this.lang];
      //     } else {
      //         this.error.body = "";
      //     }
      // }
    },
    editingCouponData: null,
    testPanel: null,
    testMobile: '',
    testSending: false,
  }),

  computed: {
    ...mapState('loyaltyPanel/campaigns/newCampaign', [
      'coupons',
      'canGoToNextStep',
      'step',
      'systemNotifications',
      'notificationVariables',
    ]),

    ...mapState(['loading']),

    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    availableCoupons() {
      let data = [...this.coupons];
      if (
        this.editOnly &&
        !this.coupons.find((coupon) => coupon.gift_id === this.editingCouponData.gift_id)
      ) {
        data.push(this.editingCouponData);
      }
      return data;
    },
    newCampaign: {
      get() {
        return this.$store.state.loyaltyPanel.campaigns.newCampaign.newCampaign;
      },
      set(val) {
        this.setNewCampaign(val);
      },
    },

    couponsQuery() {
      if (this.searchCoupons) {
        return `?q=${this.searchCoupons}&page=${this.couponsPage}`;
      }

      return `?page=${this.couponsPage}`;
    },

    selectedReward() {
      return (this.rewardTypes || []).find((x) => x.selected) || {};
    },

    sharePoints() {
      let val = this.selectedReward.options?.invoicing_settings?.both_percentages.company;
      return (val && val !== 100) || val === 0;
    },

    mentionableItems() {
      return this.notificationVariables.map((e) => ({
        value: e,
        label: this.translations[e]?.lang || e,
      }));
    },
    campaignTypes() {
      return this.$store.state.loyaltyPanel.campaigns.newCampaign.campaignTypes;
    },
    hasSmsContent() {
      const notif =
        this.newCampaign?.campaign_reward?.notification ||
        this.selectedReward?.options?.campaign_reward?.notification ||
        {};
      return (
        (notif.en && notif.en.toString().trim().length > 0) ||
        (notif.el && notif.el.toString().trim().length > 0) ||
        (notif.it && notif.it.toString().trim().length > 0)
      );
    },
    isMobileValid() {
      if (!this.testMobile) return false;
      const digits = (this.testMobile + '').replace(/\D/g, '');
      return digits.length >= 7;
    },
    selectedGift() {
      let gift = this.availableCoupons.find(
        (g) => g.gift_id === this.selectedReward.options.campaign_reward.gift_id
      );
      return gift ?? {};
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/campaigns/newCampaign', [
      'getCoupons',
      'getCampaignSystemNotifications',
      'getNotificationVariables',
      'getCampaignTypes',
      'sendRewardSmsTest',
    ]),
    ...mapMutations(['setNotification']),
    ...mapMutations('loyaltyPanel/campaigns/newCampaign', ['setCanGoToNextStep', 'setStep']),
    goToStep(val) {
      this.setStep(val);
    },
    checkValue() {
      if (
        this.newCampaign.campaign_reward.gift_id ||
        this.newCampaign.campaign_reward.multi_points_ratio ||
        this.newCampaign.campaign_reward.reward_points
      ) {
        this.disableBtn = false;
      } else {
        this.disableBtn = true;
      }
    },

    attachRewardType(val) {
      // prevent switching reward type while in edit-only mode
      if (this.editOnly && arguments.length < 2) return;
      this.selectedReward.selected = false;
      val.selected = true;
      // this.$set(
      //     this.newCampaign,
      //     "reward_system",
      //     val.system
      // );
    },

    goToNextStep() {
      if (this.selectedReward.system == 'points' && this.newCampaign.category == 'informative') {
        if (!this.newCampaign.invoicing_settings) {
          this.newCampaign.invoicing_settings = {
            both_percentages: {},
          };
        }
        this.newCampaign.invoicing_settings.company = true;
        this.newCampaign.invoicing_settings.store = false;
        this.newCampaign.invoicing_settings.both = false;
        if (!this.newCampaign.invoicing_settings.both_percentages) {
          this.newCampaign.invoicing_settings.both_percentages = {};
        }
        this.newCampaign.invoicing_settings.both_percentages.company = 0;
      }

      this.$emit('next');
    },

    handleSearchCoupons() {
      const body = {
        query: this.couponsQuery,
        page: this.couponsPage,
      };
      this.getCoupons(body);
    },

    validateStep() {
      let val = this.newCampaign.campaign_reward;
      if (
        this.selectedReward.system == 'no_reward' ||
        (this.selectedReward.system == 'points' &&
          /^\d+$/.test(val.reward_points) &&
          Number(val.reward_points) >= 0) ||
        (this.selectedReward.system == 'coupon' && val.gift_id) ||
        (this.selectedReward.system == 'multiplier' && val.multi_points_ratio)
      ) {
        this.setCanGoToNextStep(true);
      } else {
        this.setCanGoToNextStep(false);
      }
    },

    async sendTestSms() {
      try {
        if (!this.isMobileValid) return;
        this.testSending = true;
        const payload = {
          message: this.newCampaign.campaign_reward.notification,
          mobile: this.testMobile,
          coupon_id: this.selectedGift?.coupon_id,
        };
        const res = await this.sendRewardSmsTest(payload);
        this.testSending = false;
        if (res && res.data && !res.data.error) {
          this.setNotification({
            show: true,
            type: 'success',
            text: this.translations.testSent[this.lang],
          });
          this.testPanel = null;
          this.testMobile = '';
        } else {
          this.setNotification({
            show: true,
            type: 'error',
            text: res?.data?.message || this.translations.testFailed[this.lang],
          });
        }
      } catch (err) {
        this.testSending = false;
        this.setNotification({
          show: true,
          type: 'error',
          text: this.translations.testFailed[this.lang],
        });
      }
    },
    lookupCampaignType(campaign_type_id) {
      for (const category of Object.keys(this.campaignTypes)) {
        const list = this.campaignTypes[category].campaign_types || [];
        const found = list.find((ct) => ct.campaign_type_id === campaign_type_id);
        if (found) return { system: found.system, category };
      }
      return null;
    },
  },

  watch: {
    selectedReward: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.options) {
          if (val.system == 'multiplier' && !val.options.invoicing_settings) {
            val.options.invoicing_settings = {
              company: true,
              store: false,
              both: false,
              both_percentages: { company: 100 },
            };
          }
          if (this.editOnly && val.options.campaign_reward.gift_id) {
            val.options.campaign_reward.coupon_id = this.availableCoupons.find(
              (coupon) => coupon.gift_id === val.options.campaign_reward.gift_id
            )?.coupon_id;
          }
          this.newCampaign.campaign_reward = {
            ...val.options.campaign_reward,
          };
          if (!this.couponHasSms) {
            this.newCampaign.campaign_reward.notification = undefined;
          }
          if (val.options.invoicing_settings) {
            this.newCampaign.invoicing_settings = {
              ...val.options.invoicing_settings,
            };
          } else {
            this.newCampaign.invoicing_settings = undefined;
          }
        }
      },
    },
    couponHasSms: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.newCampaign.campaign_reward.notification = undefined;
        } else {
          this.newCampaign.campaign_reward.notification =
            this.selectedReward?.options?.campaign_reward?.notification;
        }
      },
    },

    ['newCampaign.campaign_reward']: {
      immediate: true,
      handler(val) {
        this.validateStep();
      },
      deep: true,
    },

    step: {
      immediate: true,
      handler(val) {
        if (val == 5) {
          this.validateStep();
        }
      },
      deep: true,
    },
    ['selectedReward.system']: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.$vuetify.goTo('#conditions', {
              duration: 300,
              offset: 50,
              easing: 'easeInOutCubic',
            });
          });
        }
      },
    },

    searchCoupons() {
      this.couponsPage = 1;
      this.debouncedSearchCoupons();
    },

    storePercentage(val) {
      this.selectedReward.options.invoicing_settings.both_percentages.company = 100 - Number(val);
      this.selectedReward.options.invoicing_settings.store = Number(val) == 100;
      this.selectedReward.options.invoicing_settings.both = Number(val) < 100 && Number(val) > 0;
    },
    ['newCampaign.invoicing_settings']: {
      handler(val) {
        if (val) {
          let companyVal = val?.both_percentages?.company || 100;
          if (companyVal < 0 || companyVal > 100) {
            this.percentageError = 'The percentage must be from 0 to 100';
            this.disableBtn = true;
          } else {
            this.percentageError = '';
            this.disableBtn = false;
            if (!this.newCampaign.invoicing_settings.both_percentages) {
              this.newCampaign.invoicing_settings.both_percentages = {};
            }
            this.newCampaign.invoicing_settings.both_percentages.company = Number(companyVal);
            this.storePercentage = 100 - Number(companyVal);

            if (!this.selectedReward.options.invoicing_settings) {
              this.selectedReward.options.invoicing_settings = {};
            }
            this.selectedReward.options.invoicing_settings.company = !this.storePercentage;
          }
        }
      },
      deep: true,
    },
    ['selectedReward.options.campaign_reward.notification']: {
      handler(val) {
        if (val) {
          let langCapital = this.smsLang[0].toUpperCase() + this.smsLang[1]; //ex. En
          if (this.lang == this.smsLang) {
            if (this.smsLang != 'el' && this.changeSmsElAuto && val.el != val[this.smsLang]) {
              val.el = val[this.smsLang];
            }

            if (this.smsLang != 'it' && this.changeSmsItAuto && val.it != val[this.smsLang]) {
              val.it = val[this.smsLang];
            }

            if (this.smsLang != 'en' && this.changeSmsEnAuto && val.en != val[this.smsLang]) {
              val.en = val[this.smsLang];
            }

            this[`changeSms${langCapital}Auto`] = false;
          } else if (val[this.smsLang] != val[this.lang]) {
            this[`changeSms${langCapital}Auto`] = false;
          }
        }
      },
      deep: true,
    },
    storeMode: {
      immediate: true,
      handler(newMode) {
        let pointsReward = this.rewardTypes.find((reward) => reward.system === 'points');
        if (pointsReward && newMode) {
          if (newMode === 'cashback') {
            pointsReward.name = {
              en: 'Cashback',
              el: 'Επιστροφή Χρημάτων',
              it: 'Rimborso',
            };
          } else {
            pointsReward.name = {
              en: 'Points',
              el: 'Πόντοι',
              it: 'Punti',
            };
          }
        }
      },
    },
  },

  async mounted() {
    this.validateStep();
    this.getNotificationVariables();
    this.smsLang = this.$route.params.lang;
    this.getCampaignSystemNotifications();

    if (!this.selectedReward?.system) {
      this.attachRewardType(this.rewardTypes.find((x) => x.system == 'no_reward'));
    }
    if (this.editOnly && this.initialCampaign?.reward) {
      if (!this.campaignTypes?.length) {
        await this.getCampaignTypes();
      }
      let initialCampaignType = this.lookupCampaignType(this.initialCampaign.campaign_type_id);

      this.newCampaign.category = initialCampaignType?.category;
      this.newCampaign.campaign_reward = { ...this.initialCampaign.reward };

      const foundType =
        this.rewardTypes.find((x) => x.system === this.initialCampaign.reward.system) || null;
      if (foundType) {
        this.attachRewardType(foundType, true);
        if (foundType.system === 'coupon') {
          let editingCoupon = this.initialCampaign.reward.coupon;
          if (editingCoupon.notification) {
            this.couponHasSms = true;
            this.selectedReward.options.campaign_reward.notification = editingCoupon.notification;
          }
          if (editingCoupon.coupon_claim_valid_days) {
            this.selectedReward.options.campaign_reward.coupon_claim_valid_days =
              editingCoupon.coupon_claim_valid_days;
          }
          this.editingCouponData = {
            gift_id: editingCoupon.gift_id || 0,
            gift_title: editingCoupon.title || '',
            coupon_id: editingCoupon.coupon_id,
          };
          this.coupons.push(this.editingCouponData);

          this.searchCoupons = this.editingCouponData.gift_title;
          this.selectedReward.options.campaign_reward.gift_id = this.editingCouponData.gift_id;
          this.selectedReward.options.campaign_reward.coupon_id = this.editingCouponData.coupon_id;
        }
        if (foundType.system === 'multiplier') {
          this.selectedReward.options.campaign_reward.multi_points_ratio =
            this.initialCampaign.reward.multi_points_ratio;
        }
        if (foundType.system === 'points') {
          this.selectedReward.options.campaign_reward.reward_points =
            this.initialCampaign.reward.reward_points;
        }
      } else {
        this.attachRewardType(this.rewardTypes.find((x) => x.system == 'no_reward'));
      }

      this.validateStep();
    }
  },
  created() {
    this.debouncedSearchCoupons = debounce(this.handleSearchCoupons, 500);
  },
};
</script>

<style scoped>
.border-grey {
  border: 2px solid grey;
}

.b-outlined {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.icon-container {
  /* margin-top:20px; */
  height: 200px;
  width: 200px;
}
.select-category {
  cursor: pointer;
  transition: all 0.5s ease-out;
  background-color: white;
  min-width: 200px;
  font-size: 22px;
  color: gray;
  /* border: 1px solid black */
}
.select-category:hover {
  /* background-color: rgba(0, 0, 0, 0.2); */
  background-color: #27272730;
  color: black;
  border-color: black;
  /* font-size: 26px; */
}

.invisible {
  opacity: 0;
  z-index: 0;
}

.overlapped {
  position: absolute;
}

.transition-all {
  transition:
    all 1s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 2.5s,
    background-position 1.5s,
    opacity 1s;
}
.back-button {
  position: absolute;
  top: 45%;
  z-index: 10;
}
.mw-100 {
  min-width: 100% !important;
}
.mxw-150px {
  max-width: 150px !important;
}
.mw-180 {
  min-width: 180px !important;
}
.selected-condition {
  color: white;
  background: #272727;
  border-color: #272727;
}

.selected-condition .v-icon {
  background: white;
  color: #272727;
}
.selected-condition .border-grey {
  border-color: #272727;
}
.display-none {
  display: none !important;
}
.no-border {
  border: none !important;
}

.footer-options-reward-sms {
  position: relative;
  display: flex;
  align-items: end;
  min-width: 100%;
  height: 0;
  margin-top: -4px;
}
.test-panel .v-expansion-panel-header {
  min-height: 38px;
}
.test-reward-sms-panel {
  max-width: 220px;
}
.reward-sms-test-mobile {
  max-width: 180px;
}
</style>
